import Buttons from "./buttons";
import Tooltip from "../Tooltip";
import ReactMarkdown from "react-markdown";
import * as Styled from "./row.style";

const row = ({ label, value, tooltip, buttons }) => {
  return (
    <Styled.Row>
      <Styled.RowKey>
        <ReactMarkdown>{label}</ReactMarkdown>
      </Styled.RowKey>
      <Styled.RowValue>
        <span>{value}</span>
        {buttons && (
          <Buttons
            onIncrease={buttons.onIncrease}
            onDecrease={buttons.onDecrease}
            isAtMax={() => buttons.isAtMax(value)}
            isAtMin={() => buttons.isAtMin(value)}
          />
        )}
      </Styled.RowValue>
      {tooltip && (
        <Styled.RowTooltip>
          <Tooltip entries={tooltip} className="row_tooltip" />
        </Styled.RowTooltip>
      )}
    </Styled.Row>
  );
};

export default row;
